<template>
  <div>
    <div class="form-group row" v-if="currentGapContent">
      <div class="col-md-12">
        <h4>{{ $t('gap_question') }}</h4>
        <div>
          <p>{{currentGapContent}}</p>
        </div>
      </div>
    </div>
    <div class="form-group row" v-if="currentGap.help_text">
      <div class="col-md-12 accordion-icons" id="helpAccordion">
        <div role="menu" class="collapsed" data-toggle="collapse" data-target="#help_text" aria-expanded="false" aria-controls="help_text">
          <div class="accordion-icon dkl-red"><i class="fa fa-question"></i></div>
          {{ $t('help_text') }}
        </div>

        <div id="help_text" class="collapse" data-parent="#helpAccordion">
          <div class="dkl-font-13 dkl-border-1-gray">{{ help_text }}</div>
        </div>
      </div>
    </div>
    <div class="form-group row" v-if="currentGap.dsgvo_reference">
      <div class="col-md-12 accordion-icons" id="referenceAccordion">
        <div role="menu" class="collapsed" data-toggle="collapse" data-target="#dsgvo_reference" aria-expanded="false" aria-controls="dsgvo_reference">
          <div class="accordion-icon dkl-red"><i class="fa fa-question"></i></div>
          {{ $t('gdpr_reference') }}
        </div>

        <div id="dsgvo_reference" class="collapse" data-parent="#referenceAccordion">
          <div class="dkl-font-13 dkl-border-1-gray">{{ dsgvo_reference }}</div>
        </div>
      </div>
    </div>
    <div class="form-group row" v-if="currentGap.sample_text">
      <div class="col-md-12 accordion-icons" id="sampleTextAccordion">
        <div role="menu" class="collapsed" data-toggle="collapse" data-target="#sample_text" aria-expanded="false" aria-controls="sample_text">
          <div class="accordion-icon dkl-red"><i class="fa fa-question"></i></div>
          {{ $t('text_block') }}
        </div>

        <div id="sample_text" class="dkl-font-13 collapse" data-parent="#sampleTextAccordion">
          <div class="dkl-border-1-gray">{{currentGap.sample_text}}</div>
          <div><a target="_blank" href="https://mandantenbereich.datenschutzkanzlei-lenz.de/library/d635b463-be55-4992-bb8b-7e88cc63dee0/DKL_Allgemein/DKL_Vorlagen_Mandanten/01.02_DSMS_Dokumentenvorlagen">{{ $t('template_link') }}</a></div>
        </div>
      </div>
    </div>
    <div class="form-group row" v-if="currentGapContent">
      <div class="col-md-12">
        <div class="van-divider--dashed"></div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <div class="d-flex">
          <label class="col-form-label">{{ $t('actual_status') }} <span class="text-danger">*</span></label>
          <div class="dkl-flex-center ml-5">
            <input type="radio" name="statement-yes" class="ml-2"  value="yes" v-model="answerType">
            <label for="statement-yes" class="ml-1 mb-0">{{ $t('yes') }}</label>
            <input type="radio" name="statement-no" class="ml-2"  value="no" v-model="answerType">
            <label for="statement-no" class="ml-1 mb-0">{{ $t('no') }}</label>
            <input type="radio" name="statement-partial" class="ml-2"  value="partial" v-model="answerType">
            <label for="statement-partial" class="ml-1 mb-0">{{ $t('others') }}</label>
          </div>
        </div>
        <textarea class="form-control" name="comments" rows="8" v-model="currentAnswer.comments"></textarea>
        <div class="input-errors" v-for="error of v$.currentAnswer.comments.$errors" :key="error.$uid">
          <div class="error-msg text-danger">{{ $t('required_field') }}</div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12 custom-control custom-checkbox" style="padding-left: 35px!important;">
        <input type="checkbox" class="custom-control-input" id="generateTask" v-model="generateTask">
        <label class="custom-control-label" for="generateTask">{{ $t('create_task') }}</label>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <label class="col-form-label">{{ $t('communicated_by') }} </label>
        <input class="form-control" name="given_by" type="text" v-model="currentAnswer.given_by"></input>
      </div>
      <div class="col-md-6">
        <label class="col-form-label">Stand <span class="text-danger">*</span></label>
        <input class="form-control" name="stand" type="text" v-model="currentAnswer.stand"></input>
        <div class="input-errors" v-for="error of v$.currentAnswer.stand.$errors" :key="error.$uid">
          <div class="error-msg text-danger">{{ $t('required_field') }}</div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12">
        <label class="col-form-label">{{ $t('documents') }}</label>
        <textarea class="form-control" name="document" rows="5" v-model="currentAnswer.document" :placeholder="currentGap.sample_document"></textarea>
        <div class="float-right">
          <button type="button" class="btn btn-sm btn-success" @click.prevent="saveStand" :key="btnKey" :disabled="btnDisabled">
            <i class='uil uil-message me-1'></i>{{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue'
import {mapMutations, mapState} from "vuex";
import {required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import service from "@/utils/request";
import {ajaxErrorMessage} from "@/utils";

export default {
  name: "NewGapStandComponent",
  props: {
    currentAnswer: {
      type: Object,
      required: true
    },
    currentGapContent: {
      type: String,
      default: ''
    },
    currentGap: {
      type: Object,
      default: {
        sample_document: ''
      }
    }
  },
  data() {
    return {
      btnKey: 1,
      btnDisabled: false,
      answerType: '',
      standardAnswer:{},
      generateTask: true
    }
  },
  validations() {
    return {
      currentAnswer: {
        comments: {required, $lazy: true},
        stand: {required, $lazy: true}
      },
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  watch:{
    currentAnswer: {
      handler: function (newValue, oldVal) {
        if (!this.modalDirty) this.setModalDirty(true)
      },
      deep: true
    },
    answerType(newValue) {
      this.currentAnswer.comments = this.currentAnswer[newValue]
      if (newValue !== 'yes') {
        this.generateTask = true
      } else {
        this.generateTask = false
      }
    }
  },
  computed: {
    ...mapState({
      userID: state => state.user.id,
      modalDirty: state => state.app.modalDirty,
      language: state => state.app.language
    }),
    dsgvo_reference() {
      if (this.language === 'de') return this.currentGap.dsgvo_reference;
      return this.currentGap.dsgvo_reference_en;
    },
    help_text() {
      if (this.language === 'de') return this.currentGap.help_text;
      return this.currentGap.help_text_en;
    },
  },
  methods: {
    ...mapMutations({setModalDirty: 'SET_MODALDIRTY'}),
    enableClickOnce() {
      this.btnKey++
    },
    async saveStand() {
      if (!this.currentAnswer.modified_by || this.currentAnswer.modified_by === '') this.currentAnswer.modified_by = this.userID
      const isValid = await this.v$.currentAnswer.$validate()
      if (!isValid) {
        this.$vToastify.error(this.$t('complete_missing_fields'))
        // this.enableClickOnce()
        return
      }
      this.btnDisabled = true
      let url = 'todos/v1/save_answer/'
      if (this.currentAnswer.id) url = `todos/v1/update_answer/${this.currentAnswer.id}/`
      service.request({
        url: url,
        method: 'POST',
        responseType: 'json',
        data: this.currentAnswer
      }).then((response) => {
        //this.enableClickOnce()
        this.btnDisabled = false
        this.answerType = ''
        this.v$.$reset()
        this.$emit('standUpdated', response.data, this.generateTask)
        this.$vToastify.success(`${this.$t('actual_status')} ${this.$t('save_success_msg')}`)
      }).catch(error => {
        //this.enableClickOnce()
        this.btnDisabled = false
        this.answerType = ''
        this.$vToastify.error(ajaxErrorMessage(error))
      })
    }
  }
}
</script>

<style scoped>

</style>
